enum ProcoreRequestType {
  DEVIATIONS = "deviations",
  PROGRESS = "progress",
  PUSH_ISSUES = "push_issues"
}

export default ProcoreRequestType;